// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Du6iS","col":"styles_col___B50b","actions":"styles_actions__1E3hz","conflict":"styles_conflict__1biPb"};